var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "close-orange.7dfb2094.png","uri@2x": __webpack_public_path__ + "close-orange.04d741da.png","uri@3x": __webpack_public_path__ + "close-orange.db63d09c.png",
    width: 37,
    height: 37
});